import Tagify from '@yaireo/tagify';
import { debounce } from 'lodash';

function initTagify(input) {
  const apiUrl = input.dataset.url;
  const tagify = new Tagify(input, {
    enforceWhitelist: true,
    autoComplete: {
      enabled: true,
      rightKey: true,
    },
    originalInputValueFormat: (values) => values.map((item) => item.value).join(','),
  });
  if (apiUrl) {
    // see: https://github.com/yairEO/tagify#ajax-whitelist
    const onInput = (e) => {
      const inputValue = e.detail.value;
      if (inputValue.length < 2) {
        return;
      }
      tagify.settings.whitelist.length = 0; // reset current whitelist
      tagify.loading(true).dropdown.hide.call(tagify); // show the loader animation

      const search = new URLSearchParams({ name: inputValue });
      fetch(`${apiUrl}?${search}`)
        .then((response) => response.json())
        .then((json) => {
          const names = json.universities.filter((data) => !/大学院$/.test(data.name)).map((data) => data.name);
          tagify.settings.whitelist.push(...names, ...tagify.value);
          tagify.loading(false).dropdown.show.call(tagify, e.detail.value);
        })
        .catch((_err) => tagify.dropdown.hide.call(tagify));
    };
    const debouncedOnInput = debounce(onInput, 500);
    tagify.on('input', debouncedOnInput);
  }
  initCategoryButtons(tagify, input.id);
}

function initCategoryButtons(tagify, targetId) {
  const checkboxes = document.querySelectorAll(`.js-search-university-category-checkbox[data-target="${targetId}"]`);
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', (e) => {
      const values = JSON.parse(checkbox.dataset.values);
      if (e.currentTarget.checked) {
        tagify.addTags(values);
      } else {
        tagify.removeTags(values);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('.js-search-university-name');
  inputs.forEach((input) => initTagify(input));
});
